import { render, staticRenderFns } from "./DateFormatsEditor.vue?vue&type=template&id=d4dcc456&scoped=true&"
import script from "./DateFormatsEditor.vue?vue&type=script&lang=js&"
export * from "./DateFormatsEditor.vue?vue&type=script&lang=js&"
import style0 from "./DateFormatsEditor.vue?vue&type=style&index=0&id=d4dcc456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dcc456",
  null
  
)

export default component.exports